"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReservationButton = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ReservationOfProduct;
try {
  ReservationOfProduct = require("react-platform-reservation/dist/Reservation/index").default;
} catch (error) {}
var ReservationButton = function ReservationButton(props) {
  var product = props.product,
    editButton = props.editButton;
  return ReservationOfProduct && (props.showReservationButton ? props.showReservationButton(product) : true) && /*#__PURE__*/_react.default.createElement(ReservationOfProduct, _extends({
    product: product,
    editButton: editButton
  }, props));
};
exports.ReservationButton = ReservationButton;